<template>
  <v-row justify="center">
    <v-dialog v-model="dialog" persistent max-width="400px">
      <template v-slot:activator="{ on, attrs }">
        <v-icon
          color="primary"
          dark
          v-bind="attrs"
          v-on="on"
          small
          >fas fa-pencil-alt
        </v-icon>
      </template>
      <v-card>
        <v-card-title>
          <span class="headline">Edit Contact</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form
              ref="form"
              v-model="valid"
            >
            <v-row>
              <v-col cols="12">
                <v-text-field
                  v-model="contact.name"
                  label="Contact Name"
                  type="text"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="contact.email"
                  label="Contact Email"
                  type="email"
                  :rules="[v => !!v || 'Item is required',v => /.+@.+\..+/.test(v) || 'E-mail must be valid']"
                  required
                ></v-text-field>
              </v-col>
              <v-col cols="12">
                <v-text-field
                  v-model="contact.mobile"
                  label="Mobile No"
                  type="number"
                  :rules="[v => !!v || 'Item is required']"
                  required
                ></v-text-field>
              </v-col>

            </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
          <v-btn color="success darken-1" text :disabled="!valid" @click="editcontact1()">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import { mapGetters,mapActions } from 'vuex';
  export default {
    props : {
        contactid : Number,
        projectid : Number
    },
    data: function() {
      return {
        valid: true,
        dialog: false,
        contact: ''
      }
    },
    computed: {
      ...mapGetters(["allcontacts"])
    },
    created () {
      let contact1 = this.allcontacts.filter(product => product.id === this.contactid);
      this.contact = contact1[0];
    },
    methods:{
      ...mapActions(['editcontact']),
      editcontact1() {
        if(this.$refs.form.validate())
        {
          this.editcontact({contact : this.contact,projectid :this.projectid});
          this.dialog = false;
        }
      }
    }
  }
</script>